import { ExtendedOrder } from '@customTypes/order';
import { Requisition } from '@customTypes/requisition';
import { PRODUCT_ID_DATA_ONLY } from '@constants/constants';
import { useSettings } from '@hooks/useSettings';

import PatientDetailOrderStatusTimeline from '../../PatientDetailOrderStatusTimeline/PatientDetailOrderStatusTimeline';

import PatientDetailOrderCard from './PatientDetailOrderCard';
import { PatientDetailOrderNotifications } from './PatientDetailOrderNotifications';
import RelatedOrders from './RelatedOrders';

import './PatientDetailOrderContent.scss';

interface PatientDetailOrderContentProps {
  requisition: Requisition;
  orders: ExtendedOrder[];
  /** True when the parent order row is expanded; used to start the notifications fetch. */
  orderOpen: boolean;
}

export default function PatientDetailOrderContent({
  requisition,
  orders,
  orderOpen,
}: PatientDetailOrderContentProps) {
  const { isNatera } = useSettings();
  const hasRelatedOrders = !!requisition.case_requisitions?.length;

  return (
    <div className='patient-detail-order-content'>
      <PatientDetailOrderStatusTimeline requisition={requisition} />
      <hr className='patient-detail-order-content__divider' />
      {orders.some(o => o.product_id === PRODUCT_ID_DATA_ONLY) && (
        <p className='patient-detail-order-content__duo-trio-notice'>
          This individual is included in a duo or trio order and will not receive a separate exome/genome report.
          Results will be delivered to the proband&apos;s order, which is linked below.
        </p>
      )}

      <div className='patient-detail-order-content__cards'>
        {orders
          .filter(order => order.product_id !== PRODUCT_ID_DATA_ONLY)
          .map(order => (
            <PatientDetailOrderCard key={order.order_id} order={order} requisitionId={requisition.requisition_id} />
          ))}
      </div>

      {hasRelatedOrders && <RelatedOrders requisitions={requisition.case_requisitions!} />}

      {!isNatera && (
        <PatientDetailOrderNotifications
          requisitionId={requisition.requisition_id}
          enabled={orderOpen}
        />
      )}
    </div>
  );
}
